import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../navbar';
import TopNavbar from '../topnavbar';
import Footer from '../footer';
import '../../App.css'; 
import { base64pdf } from '../../vblob';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button'; 
//import emailjs from '@emailjs/browser'; 
import "react-pdf/dist/esm/Page/TextLayer.css"; 
import { insertNotification, sendEmail } from '../globalFunctions'; 
import { Document, Page, pdfjs } from 'react-pdf'; 
import { ToastContainer, toast } from 'react-toastify';

function RequestView() {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`; 

  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state.data;
  const fromMaternityTracker = location.state?.fromMaternityTracker || false;

  const HrEmail = sessionStorage.getItem("email");
  const HrEmpId = sessionStorage.getItem("employeeId");
  const HrName = sessionStorage.getItem("firstName") + " " + sessionStorage.getItem("lastName");

  const [showModal, setShowModal] = useState(false);
  const [numPages, setNumPages] = useState(); 
  const [pdfUrl, setPdfUrl] = useState(''); 
  const [imageUrl, setImageUrl] = useState('');
  const [fileName, setFileName] = useState('');
  const [pdf, setPdf] = useState([]); 
  const [isCompleted, setIsCompleted] = useState(false);
  const [isForResubmission, setIsForResubmission] = useState(false);

  // Converts base64 to pdf
  const convertToPDF = (base64) => {
    const binaryString = atob(base64 ? base64 : base64pdf.blobpdf2);
    const arrayBuffer = new ArrayBuffer(binaryString.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryString.length; i++) {
      uint8Array[i] = binaryString.charCodeAt(i);
    } 
    const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    setPdfUrl(url);
    return url;
  }

  const convertToImage = (base64, type) => {
    const binaryString = atob(base64);
    const arrayBuffer = new ArrayBuffer(binaryString.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryString.length; i++) {
      uint8Array[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([arrayBuffer], { type: `image/${type}` });
    return URL.createObjectURL(blob);
  };

  const convertAndDownloadPDF = (base64, fileName) => {
    const url = convertToPDF(base64);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  useEffect(() => {   
    getSubmissionPDF();
  },[]); 

  const getSubmissionPDF = async () => { 
    const formData = new FormData();
    formData.append('SubmissionID', data.SubmissionID);
    try {
      const uploadResponse = await fetch('/api/submissionpdf', { method: 'POST', body: formData });
      if (!uploadResponse.ok) return;
      const responseData = await uploadResponse.json();   
      if(responseData.result){
        const sortedData = responseData.result.sort((a, b) => {   
          if (a.RequirementName !== b.RequirementName) {
            return a.RequirementName.localeCompare(b.RequirementName);
          } else { 
            return b.Updated - a.Updated;
          }
        }); 
        setPdf(sortedData);
      }
    } catch (error) {
      console.error('Error fetching PDFs:', error);
    }
  }; 

  const handleFormSubmit = async (e) => {
    e.preventDefault();   
    const reasonArray = [];
    const documentNameArray = []; 
    let hasEmptyReason = false;

    pdf.forEach(pdf => {
      if (pdf.Resubmit && !pdf.ResubmitReason) {
        hasEmptyReason = true;
      }
      if(pdf.Resubmit && pdf.ResubmitReason && !pdf.Updated){ 
        documentNameArray.push(pdf.RequirementName); 
        reasonArray.push(pdf.ResubmitReason);
        updatePdf(pdf);
      }
    }); 

    if (hasEmptyReason) {
    toast.warn('Please provide a reason for all checked items.', {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
     return;
    }

    let documentName = documentNameArray.join(', ').replace(/,([^,]*)$/, ' &$1'); 
    let reason = reasonArray.join(', ').replace(/,([^,]*)$/, ' & $1');
    if(reasonArray.length > 1) reason += ' respectively';
    if(reasonArray.length !== 0 && documentNameArray.length !== 0) { 
      insertNotification(data.Name, data.TransactionType, HrEmpId, data.EmpId, 'resubmit', data.SubmissionID); 
      // sendEmail('resubmit', reason, documentName); 
      try {
       const facility =
        data.Facility ||
        data.facility ||
        sessionStorage.getItem("facility");

        console.log("resubmit facility:", facility);

        const emailResult = await sendEmail('resubmit', {
          Name: data.Name,
          EmailAddress: data.EmailAddress,
          TransactionType: data.TransactionType,
          documentName: documentName,
          reason: reason,
          stopDeduction: false,
          facility: facility
        });

        if (!emailResult) {
          console.error("Resubmit email was not sent.");
        }
      } catch (error) {
        console.error("Error sending resubmit email:", error);
      }      //getSubmissionPDF();
      toast.success('Request to change has been submitted.', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      setTimeout(() => {
         navigate("/hriassist");
      }, 800);   // give toast time to appear
    }
  };

const updatePdf = async (pdfSubmit) => { 
  const formData = new FormData();
  formData.append('id', pdfSubmit.PdfFileID); 

  // truncate reason to 255 characters to match DB
  const reason = (pdfSubmit.ResubmitReason || '').slice(0, 255);
  formData.append('reason', reason); 
  formData.append('SubmissionID', pdfSubmit.SubmissionID); 

  try {
    const uploadResponse = await fetch('/api/updatepdf', { 
      method: 'POST', 
      body: formData,
    });

    console.log(uploadResponse);

    if (!uploadResponse.ok) {
      console.error('Failed:', uploadResponse.statusText);
      toast.error('Failed to submit the change request.', {
        position: "top-right",
      });
    } else {
      //setTimeout(() => window.location.reload(), 2000);
    }
  } catch (error) {
    console.error('Error:', error);
    toast.error('An error occurred. Please try again later.', {
      position: "top-right",
    });
  }
};


  const completeSubmission = async () => { 
    const formData = new FormData();
    formData.append('id', data.SubmissionID);  
    try {
      const uploadResponse = await fetch('/api/updatesubmission', { method: 'POST', body: formData });
      if (!uploadResponse.ok) return;  
      insertNotification(data.Name, data.TransactionType, HrEmpId, data.EmpId, 'complete', data.SubmissionID);
        toast.success('Request now has been completed.', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
        setIsCompleted(true);
        setTimeout(() => {
          navigate("/hriassist");
        }, 3000);

      
        try {
          const content = {
              HrName: '',
              HrEmail: '', // hr's email
              Name: sessionStorage.getItem("firstName") + " " + sessionStorage.getItem("lastName"),
              EmailAddress: sessionStorage.getItem("email"), // employee's email
              TransactionType: data.RequestTitle,
              documentName: '',
              reason: '',
              stopDeduction: false,
              facility: sessionStorage.getItem("facility")
          };
          
          const result = await sendEmail('complete', {
            HrName: HrName,
            HrEmail: HrEmail,
            Name: data.Name,
            EmailAddress: data.EmailAddress,
            TransactionType: data.TransactionType,
            documentName: '',
            reason: '',
            stopDeduction: false,
            facility: data.Facility || data.facility || sessionStorage.getItem('facility')
          });
           if (result) navigate("/hriassist");  
        } catch (error) {
          console.error('Error sending email:', error); 
        }
      
    } catch (error) {
      console.error('Error:', error);
    }
  };

  // const handleButtonClick = (data) => {
  //   setFileName(data.FileName);
  //   if (
  //     data.ContentType === '.pdf' ||
  //     data.ContentType === 'application/pdf' ||
  //     data.FileName?.toLowerCase().endsWith('.pdf')
  //   ) {
  //     convertToPDF(data.PdfData);
  //     setImageUrl(''); 
  //   } else {  
  //     const url = convertToImage(data.PdfData, data.ContentType); 
  //     setImageUrl(url); 
  //     setPdfUrl(''); 
  //   }
  //   setShowModal(true);
  // };
  
  const handleButtonClick = (data) => {
        setFileName(data.FileName || "File");
        setPdfUrl('');
        setImageUrl('');

        const fileName = (data.FileName || '').toLowerCase();
        const contentType = (data.ContentType || '').toLowerCase();
        const isPdf = fileName.endsWith('.pdf') || contentType.includes('pdf');

        if (isPdf) {
            convertToPDF(data.PdfData);
        } else {
            let imageType = 'jpeg';
            if (contentType.includes('png') || fileName.endsWith('.png')) imageType = 'png';
            else if (contentType.includes('gif') || fileName.endsWith('.gif')) imageType = 'gif';
            else if (contentType.includes('webp') || fileName.endsWith('.webp')) imageType = 'webp';

            setImageUrl(convertToImage(data.PdfData, imageType));
        }
        setShowModal(true);
    };
  const handleCloseModal = () => setShowModal(false);

  const checkbox = (id, status) => { 
    const isChecked = status.target.checked;
    const index = pdf.findIndex(pdf => pdf.PdfFileID === id);
    if (index !== -1) {
      pdf[index].Resubmit = isChecked; 
      setPdf([...pdf]); 
    }

    // Enable Request button if at least one checkbox is checked
    const anyChecked = pdf.some(item => item.Resubmit);
    setIsForResubmission(anyChecked);
};
  const resubmitReason = (id, reason) => {  
    const reasonPDF = reason.target.value;
    const index = pdf.findIndex(pdf => pdf.PdfFileID === id);
    if (index !== -1) {
      pdf[index].ResubmitReason = reasonPDF; 
      setPdf([...pdf]); 
    }
  }; 

  // const sendEmail = async (type, reason, documentName) => {  
  //    console.log('facility value:', data.Facility); // ← add this
  //   console.log('full data object:', data); 
  //   let HrName = "";
  //   let HrEmail = "";
  //   let SurveyLink = "";
  //   if (data.Facility == 'Manila'){
  //     HrName = "HR People Helpdesk - Manila";
  //     HrEmail = "peoplehelpdeskmanila@innodata.com";
  //     SurveyLink = "https://bit.ly/3szxvfG";
  //   }else if(data.Facility == 'Legazpi'){
  //     HrName = "HR People Helpdesk - Legazpi";
  //     HrEmail = "peoplehelpdesklegazpi@innodata.com";
  //     SurveyLink = "https://forms.office.com/pages/responsepage.aspx?id=NMWSvmB7MEa8AexRIlSNR-UfVB4wqCNIrq4mQIq8JxlURDBVQlJKM1RIMkhDRjRSNUw3UVY2WlJPQi4u";
  //   } else{
  //     HrName = "HR People Helpdesk - Cebu";
  //     HrEmail = "HRComp_Ben@innodata.com";
  //     SurveyLink = "https://forms.office.com/r/Gha0bdyNKw";
  //   }

  //   const content = {
  //     sender_name: HrName,
  //     sender_email: HrEmail,
  //     receiver_name: data.Name,
  //     receiver_email: data.EmailAddress,
  //     transaction_type: data.TransactionType,
  //     facility: data.Facility,
  //     document_name: documentName,
  //     reason: reason,
  //     surveyLink:SurveyLink
  //   };  

  //   try {
  //     const result = await sendEmailjs(type, content);
  //     return result ? Promise.resolve(true) : Promise.reject(false);
  //   } catch (error) {
  //     return Promise.reject(false);
  //   }
  // };
  

  return (
    <div id="wrapper">
      <Navbar />
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <TopNavbar />
          <div className="container-fluid">
             {fromMaternityTracker && (
              <div className="row mb-3">
                <div className="col-12">
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => navigate(-1)}
                  >
                    <span className="fa fa-arrow-left mr-2"></span> Back to Maternity Tracker
                  </button>
                </div>
              </div>
            )}
            <div className="row justify-content-center">
              <h4 className="m-0 font-weight-bold text-primary header-name">{data.TransactionType}</h4>
            </div>
            <br/>
            <div className="row justify-content-center">
              <div className="col-md-4">
                <div className="card shadow mb-4">
                  <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">Request Details</h6>
                  </div>
                  <div className="card-body">
                    <p className='mb-0'><b className='text-success'>Name:</b> {data.Name}</p>
                    <p className='mb-0'><b className='text-success'>ID:</b> {data.EmpId}</p>
                    {data.CorrectName && <p className='mb-0'><b className='text-success'>Correct Name:</b> {data.CorrectName}</p>}
                    {data.DeductionFor && <p className='mb-0'><b className='text-success'>Stop Deduction For:</b> {data.DeductionFor}</p>}
                    {data.RequestTitle && <p className='mb-0'><b className='text-success'>Request Title:</b> {data.RequestTitle}</p>}
                      {data.Description && (
                        <p className='mb-0'>
                          <b className='text-success'> {data.RequestType == 'Certificate Request (PHILHEALTH)' ? "Reason" : "Description"}:</b> {data.Description}
                        </p>
                      )}
                    {data.ErroneousName && <p className='mb-0'><b className='text-success'>Erroneous Name:</b> {data.ErroneousName}</p>}
                    {data.LoanAppDate && <p className='mb-0'><b className='text-success'>Loan Application Date:</b> {data.LoanAppDate}</p>}
                    {data.OtherReq && <p className='mb-0'><b className='text-success'>Other Request:</b> {data.OtherReq}</p>}
                    {data.ReasonType && <p className='mb-0'><b className='text-success'>Reason Type:</b> {data.ReasonType}</p>}
                    {data.RequestType && <p className='mb-0'><b className='text-success'>Request Type:</b> {data.RequestType}</p>}
                    {data.TransactionNum && <p className='mb-0'><b className='text-success'>Transaction Number:</b> {data.TransactionNum}</p>}
                    {data.TypeOfDelivery && <p className='mb-0'><b className='text-success'>Type of Delivery:</b> {data.TypeOfDelivery}</p>}
                    {data.PlaceOfConfinement && <p className='mb-0'><b className='text-success'>Place of Confinement:</b> {data.PlaceOfConfinement}</p>}
                    {data.BankAccNumber && <p className='mb-0'><b className='text-success'>Bank Account Number:</b> {data.BankAccNumber}</p>}
                    {data.CompletionDate && <p className='mb-0'><b className='text-success'>Completion Date:</b> {data.CompletionDate}</p>}
                    {data.ReasonForInfoUpdate && <p className='mb-0'><b className='text-success'>Reason For Information Update:</b> {data.ReasonForInfoUpdate}</p>}
                    {data.CurrentFullname && <p className='mb-0'><b className='text-success'>Current Full Name:</b> {data.CurrentFullname}</p>}
                    {data.NewFullname && <p className='mb-0'><b className='text-success'>New Full Name:</b> {data.NewFullname}</p>}
                    {data.CurrentCivilStatus && <p className='mb-0'><b className='text-success'>Current Civil Status:</b> {data.CurrentCivilStatus}</p>}
                    {data.NewCivilStatus && <p className='mb-0'><b className='text-success'>New Civil Status:</b> {data.NewCivilStatus}</p>}
                    <p className='mb-0'><b className='text-success'>Date Submitted:</b> {data.DateTime}</p>
                    <p className='mb-0'><b className='text-success'>Turn Around:</b> {data.TurnAround}</p>
                    <p className='mb-0'><b className='text-success'>Status:</b> {data.Status}</p>
                    {(data.Status !== 'Complete' && data.Status !== 'Expired' && data.Status !== 'Cancelled' && data.Status !== 'Resubmit' && !isCompleted) &&
                      <Button style={{marginTop: '20px'}} onClick={completeSubmission}><span className='fa fa-check'></span>  Complete Request</Button>
                    }
                  </div>
                </div>
                {data.GrossIncome || data.NetIncome ?
                                  <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <h6 className="m-0 font-weight-bold text-primary">Income Details</h6>
                                    </div>
                                    <br/>
                                    <div className="tab-content">
                                        <div className="tab-pane fade show active" id="personalDetails" role="tabpanel">
                                            <div style={{ marginRight: '40px', marginLeft: '20px', marginBottom: '20px' }}>
                                               {data.GrossIncome && (
                                                  <p className="mb-0">
                                                    <b className="text-success">Gross Income:</b>{" "}
                                                    {Number(data.GrossIncome).toLocaleString()}
                                                  </p>
                                                )}

                                                {data.NetIncome && (
                                                  <p className="mb-0">
                                                    <b className="text-success">Net Income:</b>{" "}
                                                    {Number(data.NetIncome).toLocaleString()}
                                                  </p>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :''}
              </div>

              <div className="col-md-6">
                {pdf.map((pdf, index) => (
                  <div className="card shadow mb-4" key={index}>
                    <div className="card-header py-3 d-flex justify-content-between align-items-center">
                      <h6 className="m-0 font-weight-bold text-primary">{pdf.RequirementName}</h6>
                    </div>
                    <div className="card-body">
                      <p className='mb-0'><b className='text-success'>Document:</b> {pdf.FileName}</p>
                      <p className='mb-0'><b className='text-success'>Date Submitted:</b> {pdf.UploadDate}</p>
                      <div className="d-flex justify-content-between mt-2">
                        <div className="d-flex align-items-center">
                          <label className="mr-2 mb-0">
                            {pdf.Updated ? 'Resubmission' : (data.Status !== 'Complete' && data.Status !== 'Expired' && data.Status !== 'Cancelled') ? 'Resubmit' : ''}
                          </label>
                          {(!pdf.Updated && (data.Status !== 'Complete' && data.Status !== 'Expired' && data.Status !== 'Cancelled')) && 
                            <input 
                              type="checkbox" 
                              onChange={(e) => checkbox(pdf.PdfFileID, e)} 
                              checked={pdf.Resubmit} 
                              style={{ width: '18px', height: '18px' }}
                            />
                          }
                        </div>

                        <div>
                          {/* <button className="btn btn-danger btn-sm mr-2" onClick={() => handleButtonClick(pdf)}>View</button> */}
                          <button
                            className="btn btn-danger btn-sm mr-2"
                            onClick={() => handleButtonClick(pdf, pdf.FileName?.toLowerCase().includes(".pdf"))}
                          >
                            View
                          </button>
                          <button className="btn btn-primary btn-sm" onClick={() => convertAndDownloadPDF(pdf.PdfData,pdf.FileName)}><span className='fa fa-download'></span> Download</button>
                        </div>
                      </div>
                      {pdf.Resubmit && !pdf.Updated ?
                        <div className="mt-3">
                          <label className="font-weight-bold text-primary">Reason</label>
                          <textarea className="form-control" rows="3" style={{ resize: "both" }}
                            value={pdf.ResubmitReason}
                            maxLength={255}
                            onChange={(e)=>resubmitReason(pdf.PdfFileID,e)}
                          />
                        </div>:''
                      }
                      {pdf.Updated ?
                        <div className="mt-3">
                          <label className="font-weight-bold text-danger">Reason:</label>
                          <span>{pdf.ResubmitReason}</span>
                        </div>
                      :''}
                    </div>
                  </div>
                ))}
                {(data.BankAccountNumber || data.BankName || data.BankAccount) && (
                  <div className="card shadow mb-4">
                    <div className="card-header py-3">
                      <h6 className="m-0 font-weight-bold text-primary">Bank Details</h6>
                    </div>
                    <div className="card-body">
                       {data.BankAccountName && (
                        <div className="form-group">
                          <label className="text-success font-weight-bold">Bank Account Name:</label>
                          <input 
                            type="text" 
                            className="form-control" 
                            value={data.BankAccountName} 
                            readOnly 
                          />
                        </div>
                      )}
                       {data.BankName && (
                        <div className="form-group">
                          <label className="text-success font-weight-bold">Bank Name:</label>
                          <input 
                            type="text" 
                            className="form-control" 
                            value={data.BankName} 
                            readOnly 
                          />
                        </div>
                      )}
                      {data.BankAccountNumber && (
                        <div className="form-group">
                          <label className="text-success font-weight-bold">Bank Account Number:</label>
                          <input 
                            type="text" 
                            className="form-control" 
                            value={data.BankAccountNumber} 
                            readOnly 
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
                <br />
                {data.Status !== 'Complete' && data.Status !== 'Cancelled' && data.RequestType != 'Certificate Request (PHILHEALTH)' && pdf.length > 0 &&
                  <div className="d-flex justify-content-end mt-3">
                  <button 
                    type="submit" 
                    className="btn btn-primary" 
                    onClick={handleFormSubmit}
                    disabled={!isForResubmission}
                  > Request to Change
                  </button>
                  </div>
                }
                <br />
              </div>
            </div>
          </div>

<Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
  <Modal.Header>
    <Modal.Title>{fileName}</Modal.Title>
  </Modal.Header>

    <Modal.Body
          style={{
          backgroundColor: 'lightgray',
          maxHeight: '80vh',
          overflowY: 'auto',
        }}
        >
        {pdfUrl && (
        <Document
          file={pdfUrl}
          onLoadSuccess={({ numPages }) => setNumPages(numPages)}
        >
        {Array.from({ length: numPages }, (_, i) => i + 1).map((page) => (
          <div style={{ marginBottom: '20px' }} key={page}>
            <Page
              pageNumber={page}
              renderAnnotationLayer={false}
              renderTextLayer={false}
            />
          </div>
        ))}
      </Document>
    )}
    {imageUrl && (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          src={imageUrl}
          alt="Converted Image"
          style={{
            maxWidth: '100%',
            maxHeight: '75vh',
            objectFit: 'contain',
            borderRadius: '4px',
            boxShadow: '0 0 5px rgba(0,0,0,0.2)',
          }}
        />
      </div>
    )}
  </Modal.Body>

  <Modal.Footer className="d-flex justify-content-end">
    <button type="button" className="btnClose btn btn-secondary btn-sm" onClick={handleCloseModal}>Close</button>
  </Modal.Footer>
</Modal>


          <Footer />
        </div>
      </div>
        <ToastContainer
                      position="top-right"
                      autoClose={5000}
                      hideProgressBar={false}
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      theme="light"
                  />
    </div>
  );
}

export default RequestView;